import { render } from "./TotalUsers.vue?vue&type=template&id=70c01588"
import script from "./TotalUsers.vue?vue&type=script&lang=js"
export * from "./TotalUsers.vue?vue&type=script&lang=js"

import "./TotalUsers.vue?vue&type=style&index=0&id=70c01588&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__